<div class="modal-header">
    <h5 class="modal-title">Event</h5>

    <button (click)="close()" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">

    <form (submit)="save()" *ngIf="states && states.length > 0">
        <div class="mb-3">
            <label class="form-label" i18n>Status</label>
            <select class="form-control form-select" name="event-shipment_status"
                    [(ngModel)]="newEvent.shipment_status">

                <optgroup label="-">
                    <ng-template ngFor let-state [ngForOf]="featured_states">
                        <option [ngValue]="state.key">
                            {{ state.name }} ({{state.sort}})
                        </option>
                    </ng-template>
                </optgroup>
                <optgroup label="-">
                    <ng-template ngFor let-state [ngForOf]="states">
                        <option [ngValue]="state.key">
                            {{ state.name }} ({{state.sort}})
                        </option>
                    </ng-template>
                </optgroup>
            </select>
        </div>
        <div class="mb-3">
            <label class="form-label" i18n>Note</label>
            <input type="text" class="form-control" name="status_text"
                   [(ngModel)]="newEvent.status_text">
        </div>

        <div class="form-group">
            <div class="form-check">
                <input type="checkbox" [value]="true" class="form-check-input" name="force" id="force" [(ngModel)]="newEvent.force">
                <label class="form-check-label" for="force">
                    Force </label>
            </div>
        </div>
        <div class="form-group" *ngIf="shipment && shipment.shipment_route_id && shipment.shipment_route_id!='null'">
            <div class="form-check">
                <input type="checkbox" [value]="true" class="form-check-input" name="notify_driver" id="notify_driver" [(ngModel)]="newEvent._notify_driver">
                <label class="form-check-label" for="notify_driver">
                    Send til chauffør </label>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button (click)="save()" type="button" class="btn  btn-primary"
            [disabled]="saving">{{ saving ? 'Gemmer...' : 'Gem' }}</button>
    <button (click)="close()" type="button" class="btn  btn-secondary" data-dismiss="modal" [disabled]="saving"><span
            i18n>Close</span>
    </button>
</div>
